module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4hxv1"))).then(() => parcelRequire('1iHdE'));